import { useRegion } from 'common/hooks/region';
import { ContainerTypeSelector, ShippingLineSelector } from 'components/Selectors';
import moment from 'moment';
import { usePerDiemParams } from 'pages/PerDiemArchive/params';
import * as React from 'react';
import { SpecificDateSelector, TimeSelector } from '../selectors';

interface Props {
  className?: string;
}

export const SpecificDateControls: React.FC<Props> = (props) => {
  const { className } = props;
  const { searchParams, setSearchParams } = usePerDiemParams();

  const region = useRegion();

  const minDate = React.useMemo(() => {
    return moment(region.perDiemArchiveMinDate).startOf('day');
  }, [region]);

  return (
    <div className={`flex space-x-6 ${className || ''}`}>
      <ShippingLineSelector
        value={searchParams.shippingLine}
        onChange={(shippingLine) => setSearchParams({ shippingLine })}
      />
      <ContainerTypeSelector
        value={searchParams.container}
        onChange={(container) => setSearchParams({ container })}
      />
      <SpecificDateSelector minDate={minDate} />
      <TimeSelector />
    </div>
  );
};
